import {styled} from "@mui/material/styles";
import { Card, CardContent, Grid, Typography, CardMedia } from "@mui/material";
import GpsNotFixedIcon from '@mui/icons-material/GpsNotFixed';
import { useColors } from "../../Context/ColorsContext";
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, desktop } = MediaQuerys;

export const Content = styled(CardContent)(({selected}) => {
    const { colors } = useColors();
    return {
        padding: '10px 5px 2px 5px !important',
        background: selected ? colors.main : colors.white,
        color: selected ? colors.white : colors.grayFont,
        borderRadius: '0 0 8px 8px',
        [mobile]: {
            width: '100%',
              '&::-webkit-scrollbar': {
            width: 5,
            height: '5px !important'
    },
        }
    }
})

export const GpsIcon = styled(GpsNotFixedIcon)(() => {
    const { colors } = useColors();
    return {
        color: colors.white,
        background: colors.main,
        borderRadius: 20,
        padding: 1,
        width: 20,
        height: 20,
        [desktop]: {
            width: 15,
            height: 15
        }
    }
})

export const GridCenter = styled(Grid)(({ theme }) => {
    return {
        textAlign: 'center',
        height: '130px',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center',
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background: 'white',
        [theme.breakpoints.down('md')]: {
            width: '250px',
        borderRadius: '8px 8px 0 0',
        }
    }
})

export const IconArea = styled('div')(() => {
    const { colors } = useColors();
    return {
        width: 20,
        height: 20,
        fontSize: 11,
        fontWeight: 'bold',
        color: colors.white,
        background: colors.orange,
        borderRadius: 20,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto',
        [desktop]: {
            height: 15,
            width: 15
        }
    }
})

export const CardContainer = styled(Card)(() => ({
    cursor: 'pointer',
    borderRadius: '8px',
    overflow: 'visible',
    width: 'auto',
    marginBottom: 0,
    background: 'white',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 3px 0px',
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5
    },
}))


export const Title = styled(Typography)(() => {
    return {
        [desktop]: {
            fontSize: '0.80rem'
        }
    }
})

export const ContainerGroup = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #f8f8f8',
    }
})

export const ContainerGroupRight = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '0.75rem'
    }
})

export const ContainerGroupLeft = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        gap: '0.75rem'
    }
})

export const CustomTyphography = styled(Typography)(() => {
    return {
        [desktop]: {
            fontSize: '0.65rem',
        }
    }
})

export const CustomImageNotSupportedIcon = styled(ImageNotSupportedIcon)(() => {
    const { colors } = useColors();
    return {
        color: colors.grayFont, 
        width: '50px', 
        height: '50px',
        borderRadius: '8px 8px 0 0',
        [desktop]: {
            width: '40px',
            height: '40px',
        } 
    }
})

export const CustomCardMedia = styled(CardMedia)(({ theme }) => {
    return {
        height: 130,
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background: 'white',
        [theme.breakpoints.down('md')]: {
            width: '250px'
        }

    }
})

export const ContentCard = styled('div')(() => {
    return {
        position: 'relative',
    }
})

export const CustomLabelCardMedia = styled('div')(() => {
    return {
        position: 'absolute',
        top: '0px',
        left: '0px',
        background: '#fff',
        padding: '5px',
        fontSize: '1rem',
        borderTopLeftRadius: '8px',
    }
})